import { PointsTag as PointsTagContainer, ScoreWrap, IconWrap } from "./styles";
import { BSPBody2 } from "../BSPBody2";
import React from "react";
import { CoinIcon } from "../../../../icons";

export function PointTag({ pointCount }: { pointCount: number }) {
  return (
    <PointsTagContainer>
      <IconWrap>
        {" "}
        <CoinIcon $large />
      </IconWrap>
      <ScoreWrap>
        <BSPBody2>{pointCount}</BSPBody2>
      </ScoreWrap>
    </PointsTagContainer>
  );
}
